import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import Copy from "components/copy";

import {
  ImageWrapper,
  InfoWrapper,
  InfoContent,
  Plantem,
} from "./index.styled";

const Plan = ({ data }) => {
  const { sectionClass, anchorID, copyContent, images } = data;

  return (
    <Plantem className={sectionClass} id={anchorID}>
      <InfoWrapper>
        <InfoContent>
          <Copy data={copyContent} />
        </InfoContent>
      </InfoWrapper>
      <ImageWrapper>
        <GatsbyImage
          image={getImage(images?.[0].file)}
          style={{ width: "100%", height: "100%" }}
          alt=""
        />
      </ImageWrapper>
    </Plantem>
  );
};

export default Plan;
